import TbComFile from "domain/main/com/file/TbComFile";
import TbSysBan from "domain/main/sys/ban/TbSysBan";
import TbSysPop from "domain/main/sys/pop/TbSysPop";
import { action, observable } from "mobx";

/**
 * 메인 Model
 */
export default class MainModel {
  @observable private mainBbsNewsList!: MainBbscttGeneral[];
  @observable private mainBbsInfoList!: MainBbscttGeneral[];
  @observable private mainBannerList!: TbSysBan[];
  @observable private mainFaqList!: MainFaq[];
  @observable private mainNewsNotiList!: MainFaq[];
  @observable private mainNewsExcelletList!: MainFaq[];
  @observable private cmpnyNm: string = "";
  @observable private mainPopupList!: TbSysPop[];

  @action
  public setCmpnyNm(cmpnyNm: string): void {
    this.cmpnyNm = cmpnyNm;
  }

  public getMainBbsNewsList(): MainBbscttGeneral[] {
    return this.mainBbsNewsList;
  }

  @action
  public setMainBbsNewsList(mainBbsNewsList: MainBbscttGeneral[]): void {
    this.mainBbsNewsList = mainBbsNewsList;
  }

  public getMainBbsInfoList(): MainBbscttGeneral[] {
    return this.mainBbsInfoList;
  }

  @action
  public setMainBbsInfoList(mainBbsInfoList: MainBbscttGeneral[]): void {
    this.mainBbsInfoList = mainBbsInfoList;
  }

  public getMainBannerList(): TbSysBan[] {
    return this.mainBannerList;
  }
  @action
  public setMainBannerList(mainBannerList: TbSysBan[]): void {
    this.mainBannerList = mainBannerList;
  }

  public getMainFaqList(): MainFaq[] {
    return this.mainFaqList;
  }
  @action
  public setMainFaqList(mainFaqList: MainFaq[]): void {
    this.mainFaqList = mainFaqList;
  }

  public getMainNewsNotiList(): MainFaq[] {
    return this.mainNewsNotiList;
  }
  @action
  public setMainNewsNotiList(mainNewsNotiList: MainFaq[]): void {
    this.mainNewsNotiList = mainNewsNotiList;
  }

  public getMainNewsExcelletList(): MainFaq[] {
    return this.mainNewsExcelletList;
  }
  @action
  public setMainNewsExcelletList(mainNewsExcelletList: MainFaq[]): void {
    this.mainNewsExcelletList = mainNewsExcelletList;
  }

  public getMainPopupList(): TbSysPop[] {
    return this.mainPopupList;
  }
  @action
  public setMainPopupList(mainPopupList: TbSysPop[]): void {
    this.mainPopupList = mainPopupList;
  }
}

export interface MainBbscttGeneral {
  bbscttId: string;
  bbscttNo: number;
  bbscttSj: string;
  writngDt: Date;
}
export interface MainFaq {
  notiNo: string;
  notiTpCd: number;
  notiTitle: string;
  regDate: Date;
}
export interface MainBanner {
  banExpl: string;
  banSortSeq: number;
  banNo: string;
  linkUrl: string;
  banImgPath: string;
  newWinYn: string;
  regDate: Date;
  file: TbComFile;
}
